module.exports = __webpack_public_path__ + "static/media/page3-3.c7b97af3.png";